// Shared framer-motion variants for consistent, premium section reveals.

export const fadeUp = {
  hidden: { opacity: 0, y: 40 },
  visible: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.8, ease: [0.22, 1, 0.36, 1] },
  },
};

export const stagger = {
  hidden: {},
  visible: {
    transition: { staggerChildren: 0.12, delayChildren: 0.05 },
  },
};

export const fadeUpChild = {
  hidden: { opacity: 0, y: 30 },
  visible: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.7, ease: [0.22, 1, 0.36, 1] },
  },
};

// Kinetic line reveal — used for the hero. Wrap in overflow-hidden parent.
export const lineReveal = {
  hidden: { y: "110%" },
  visible: (i = 0) => ({
    y: 0,
    transition: {
      duration: 0.9,
      ease: [0.16, 1, 0.3, 1],
      delay: 0.15 + i * 0.12,
    },
  }),
};

export const viewportOnce = { once: true, amount: 0.25 };
